<template>
<div>
    <div class="about-us">
      <el-container class="d-flex-column">
        <el-row :gutter="24">
          <el-col :span="12">&nbsp;</el-col>
          <el-col :span="12">
            <h1>Memories</h1>
            <p>Maren Solutions technologies is gifted with passel of youngsters with highly skilled capabilities of developing products and delivering on time. We have a team that includes people across our country knowing the ropes in their fields. We believe unity in diversity</p>
          </el-col>
        </el-row>
      </el-container>
    </div>
    <el-container class="d-flex-column p-tb50 text-center">
        <h2>Eid Gallery</h2>
        <p>Our team is your team. Digital specialists, tech wizzes and creative superstars –  <span class="d-block"> they know how to make a difference to your business. </span></p>
        <el-carousel :interval="5000" type="card" arrow="always">
            <el-carousel-item >
                <div class="memories-slide">
                    <img src="../../../public/img/memories/eid1.png" alt="awards" class="awards-img" >
                </div>
            </el-carousel-item>
            <el-carousel-item >
                <div class="memories-slide">
                    <img src="../../../public/img/memories/eid2.png" alt="awards" class="awards-img" >
                </div>
            </el-carousel-item>
            <el-carousel-item >
                <div class="memories-slide">
                    <img src="../../../public/img/memories/eid3.jpg" alt="awards" class="awards-img" >
                </div>
            </el-carousel-item>
        </el-carousel>
        <h2>Holi vibes</h2>
        <p>Our team is your team. Digital specialists, tech wizzes and creative superstars –  <span class="d-block"> they know how to make a difference to your business. </span></p> 
        <el-carousel :interval="5000" type="card" arrow="always">
            <el-carousel-item >
                <div class="memories-slide">
                    <img src="../../../public/img/memories/game.png" alt="awards" class="awards-img" >
                </div>
            </el-carousel-item>
            <el-carousel-item >
                <div class="memories-slide">
                    <img src="../../../public/img/memories/holi2.png" alt="awards" class="awards-img" >
                </div>
            </el-carousel-item>
            <el-carousel-item >
                <div class="memories-slide">
                    <img src="../../../public/img/memories/awards.png" alt="awards" class="awards-img" >
                </div>
            </el-carousel-item>
        </el-carousel>
    </el-container>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
  watch:{
    scobj:{
      immediate:true,
      deep: true,
      handler(){
        if(this.scobj){
          this.scobj = false
          var element = this.$refs['flightRef'];
          var top = element.offsetTop;
          window.scrollTo(0, top);
        }
      }
    }
  },
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
        }
      },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
      },
        mounted() {
          this.toggleBodyClass('addClass', 'memories');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'memories');
        }
    };
</script>


// WEBPACK FOOTER //
// Memories.vue